var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#767474"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3001_13895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.654 10.4064C16.3726 11.0993 16.7362 11.6098 17.2205 12.1952C18.4675 13.7023 18.1706 15.9245 16.6592 17.1745C15.1701 18.4053 12.9796 18.243 11.6756 16.7959C11.5253 16.6292 11.4038 16.5499 11.1536 16.5832C7.34588 17.0849 3.98991 14.1291 3.99953 10.296C4.00768 6.98388 6.55502 4.28673 9.92802 4.01849C13.0781 3.76804 16.0009 6.08952 16.5289 9.26831C16.5874 9.61879 16.6081 9.9752 16.654 10.4064ZM11.6275 14.3781C11.6327 15.8941 12.8693 17.1234 14.3762 17.1108C15.8654 17.0982 17.0909 15.8682 17.0991 14.3781C17.1072 12.8702 15.8676 11.6291 14.3599 11.6365C12.833 11.6439 11.6223 12.8583 11.6275 14.3781ZM9.93394 6.317C9.93394 7.5574 9.93394 8.75481 9.93394 9.99076C9.11791 9.99076 8.33815 9.99076 7.55544 9.99076C7.55544 10.3042 7.55544 10.5776 7.55544 10.8399C8.65657 10.8399 9.72956 10.8399 10.8085 10.8399C10.8085 9.31944 10.8085 7.82859 10.8085 6.317C10.5219 6.317 10.2583 6.317 9.93394 6.317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9463 12.4922C14.2343 12.4922 14.4987 12.4922 14.7853 12.4922C14.7853 13.3947 14.7853 14.2816 14.7853 15.2027C14.5098 15.2027 14.2395 15.2027 13.9463 15.2027C13.9463 14.3083 13.9463 13.4199 13.9463 12.4922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9419 16.3898C13.9419 16.1653 13.9419 15.9645 13.9419 15.7422C14.2285 15.7422 14.5002 15.7422 14.789 15.7422C14.789 15.9637 14.789 16.1638 14.789 16.3898C14.5076 16.3898 14.2462 16.3898 13.9419 16.3898Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3001_13895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTime);
export default __webpack_public_path__ + "static/media/ic_time.0e1cf99fe0c10f4462a7d3e91ac8a413.svg";
export { ForwardRef as ReactComponent };